<div class="toolbar-nav w-full bg-[#eab83e] flex flex-wrap relative">
  <!-- Main Categories -->
  <div
    *ngFor="
      let category of categoriesProduct
        | slice: 0 : (showAllCategories ? undefined : 8);
      let i = index
    "
    class="relative inline-block text-left mx-2"
    (mouseenter)="openCategoryMenu($event, i)"
    (mouseleave)="clearHoveredCategory()"
  >
    <div>
      <!-- Main Category Button -->
      <button
        type="button"
        (click)="goToCategory(category._id)"
        aria-label="Filter by {{ category.name }}"
        class="inline-flex justify-between items-center hover:bg-[#79273a] w-full px-2 py-2 text-sm font-medium text-white focus:outline-none transition-all duration-300"
      >
        {{ category.name }}
        <svg
          class="w-4 h-4 ml-2 -mr-1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path fill-rule="evenodd" d="M10 12l-5-5h10l-5 5z" />
        </svg>
      </button>

      <!-- Subcategories -->
      <div
        *ngIf="hoveredCategory === i"
        class="toolbar-dropdown absolute left-0 top-full w-48 shadow-lg z-20 transition-all duration-300 bg-gray-700"
        [ngClass]="{
          commoncolor: hoveredCategory === i,
          normalcolor: hoveredCategory !== i,
        }"
        [ngStyle]="categoryPopupStyle"
      >
        <ng-container
          *ngFor="let subCat of category.subCategories; let j = index"
        >
          <div
            class="relative"
            (mouseenter)="setHoveredSubCategory(j)"
            (mouseleave)="clearHoveredSubCategory()"
          >
            <a
              aria-label="Filter by {{ subCat.name }}"
              (click)="goToCategory(subCat._id)"
              class="block px-4 py-2 text-sm text-white hover:bg-gray-600 border-b border-gray-600 cursor-pointer transition-all duration-300"
            >
              {{ subCat.name }}
            </a>

            <!-- Nested Subcategories -->
            <div
              *ngIf="hoveredSubCategory === j"
              class="toolbar-submenu absolute left-full top-0 w-48 shadow-lg transition-all duration-300 bg-gray-700"
              [ngClass]="{
                commoncolor: hoveredSubCategory === j,
                normalcolor: hoveredSubCategory !== j,
              }"
            >
              <ng-container
                *ngFor="let subSubCat of subCat.subCategories; let k = index"
              >
                <div
                  class="relative"
                  (mouseenter)="setHoveredSubSubCategory(k)"
                  (mouseleave)="clearHoveredSubSubCategory()"
                >
                  <a
                    (click)="goToCategory(subSubCat._id)"
                    aria-label="Filter by {{ subSubCat.name }}"
                    class="block px-4 py-2 text-sm text-white hover:bg-gray-600 border-b border-gray-600 cursor-pointer transition-all duration-300"
                    [ngClass]="{
                      commoncolor: hoveredSubCategory === j,
                      normalcolor: hoveredSubCategory !== j,
                    }"
                  >
                    {{ subSubCat.name }}
                  </a>

                  <!-- Deepest Level Categories -->
                  <div
                    *ngIf="hoveredSubSubCategory === k"
                    class="toolbar-submenu absolute left-full top-0 w-48 shadow-lg transition-all duration-300 bg-gray-700"
                  >
                    <ng-container
                      *ngFor="let deepSubCat of subSubCat.subCategories"
                    >
                      <a
                        (click)="goToCategory(deepSubCat._id)"
                        class="block px-4 py-2 text-sm text-white hover:bg-[linear-gradient(90deg,#7B68EE_0%,#C862F8_100%)] border-b border-gray-600 cursor-pointer transition-all duration-300"
                        [ngClass]="{
                          commoncolor: hoveredSubSubCategory === k,
                          normalcolor: hoveredSubSubCategory !== k,
                        }"
                      >
                        {{ deepSubCat.name }}
                      </a>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- "More" Button with Popup -->
  <div
    *ngIf="categoriesProduct.length >= 8 && !showAllCategories"
    class="relative inline-block text-left mx-2 bg-gray-800"
    (mouseenter)="openMorePopup($event)"
    (mouseleave)="showMorePopup = false"
  >
    <button
      type="button"
      class="inline-flex justify-between items-center px-2 py-2 text-sm font-medium text-white focus:outline-none transition-all duration-300 bg-[#eab83e] hover:bg-[#79273a]"
    >
      More
      <svg
        class="w-4 h-4 ml-2 -mr-1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path fill-rule="evenodd" d="M10 12l-5-5h10l-5 5z" />
      </svg>
    </button>

    <!-- Popup Menu for Remaining Categories -->
    <!-- Popup Menu for Remaining Categories -->
    <div
      *ngIf="showMorePopup"
      class="more-menu absolute left-0 top-full commoncolor w-48 shadow-lg z-20 transition-all duration-300 bg-gray-700"
      [ngStyle]="morePopupStyle"
    >
      <ng-container
        *ngFor="let category of categoriesProduct | slice: 8; let i = index"
      >
        <div
          class="relative"
          (mouseenter)="setHoveredCategory(i + 8)"
          (mouseleave)="clearHoveredCategory()"
        >
          <a
            (click)="goToCategory(category._id)"
            class="block px-4 py-2 text-sm text-white hover:bg-[#79273a] border-b border-gray-600 cursor-pointer transition-all duration-300"
          >
            {{ category.name }}
          </a>

          <!-- Subcategories -->
          <div
            *ngIf="hoveredCategory === i + 8"
            class="more-menu-submenu absolute right-full commoncolor top-0 w-48 shadow-lg transition-all duration-300 bg-gray-700"
          >
            <ng-container
              *ngFor="let subCat of category.subCategories; let j = index"
            >
              <div
                class="relative"
                (mouseenter)="setHoveredSubCategory(j)"
                (mouseleave)="clearHoveredSubCategory()"
              >
                <a
                  (click)="goToCategory(subCat._id)"
                  class="block px-4 py-2 text-sm text-white hover:bg-gray-600 border-gray-600 cursor-pointer transition-all duration-300"
                >
                  {{ subCat.name }}
                </a>

                <!-- Nested Subcategories -->
                <div
                  *ngIf="hoveredSubCategory === j"
                  class="absolute right-full commoncolor top-0 w-48 shadow-lg transition-all duration-300 bg-gray-700"
                >
                  <ng-container
                    *ngFor="
                      let subSubCat of subCat.subCategories;
                      let k = index
                    "
                  >
                    <div
                      class="relative"
                      (mouseenter)="setHoveredSubSubCategory(k)"
                      (mouseleave)="clearHoveredSubSubCategory()"
                    >
                      <a
                        (click)="goToCategory(subSubCat._id)"
                        class="block px-4 py-2 text-sm text-white hover:bg-gray-600 border-gray-600 cursor-pointer transition-all duration-300"
                      >
                        {{ subSubCat.name }}
                      </a>

                      <!-- Deepest Level Categories -->
                      <div
                        *ngIf="hoveredSubSubCategory === k"
                        class="absolute left-full commoncolor top-0 w-48 shadow-lg transition-all duration-300 bg-gray-700"
                      >
                        <ng-container
                          *ngFor="let deepSubCat of subSubCat.subCategories"
                        >
                          <a
                            (click)="goToCategory(deepSubCat._id)"
                            class="block px-4 py-2 text-sm text-white hover:bg-[linear-gradient(90deg,#7B68EE_0%,#C862F8_100%)] border-b border-gray-600 cursor-pointer transition-all duration-300"
                          >
                            {{ deepSubCat.name }}
                          </a>
                        </ng-container>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
